import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';
import { SelectSearchDropdownComponent } from '../select-search-dropdown/select-search-dropdown.component';

interface activeClientUnderMarketingList {
  clientName: string;
  email: string;
  phoneNumber: number;
  connectedOn: string;
  leadType: string;
  leadStatus: string;
  leadCaptureDate: string;
}

@Component({
  providers: [SelectSearchDropdownComponent],
  selector: 'app-marketing-effectiveness',
  templateUrl: './marketing-effectiveness.component.html',
  styleUrls: ['./marketing-effectiveness.component.scss'],
})
export class MarketingEffectivenessComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('clientListContainer') clientListContainer: ElementRef;
  @Input() filterForMarketingTab;

  investorUsersCount: number;
  clientNameList: Array<any>;
  clientFilterForm: FormGroup = this.formBuilder.group({
    recommendationType: ['all'],
    search: [''],
  });
  fetchClientsParams = { orderBy: 'createdDate', orderType: 'desc', limit: 10, offset: 0 };
  isDataLoading: boolean = false;
  isDisableFilterBtn = false;
  isDisableResetBtn = false;
  clearSearch = 'hide';
  tableDataSource = new MatTableDataSource<activeClientUnderMarketingList>([]);
  tableColumnList: string[] = [
    'clientName',
    'email',
    'totalActivityScore',
    'lastActivityDate',
    // 'activationDate',
    'leadType',
    'leadStatus',
    'emailVerificationDate',
    'createdDate',
    'totalCount',
  ];
  requestData: { limit: number; offset: number; orderBy: string; orderType: string; filter: any } = {
    limit: this.fetchClientsParams.limit,
    offset: this.fetchClientsParams.offset,
    orderBy: this.fetchClientsParams.orderBy,
    orderType: this.fetchClientsParams.orderType,
    filter: {},
  };
  userRole: string;
  reset = [];
  selectedVerificationStatus: any;
  selectedLeadStatus: any;
  pageSize: any;
  pageIndex: number;
  onDestroyNotifier$ = new Subject();

  constructor(
    private clientDashboardService: ClientDashboardService,
    public clientDashboardState: ClientDashboardState,
    public formBuilder: FormBuilder,
    public authorizeService: AuthorizeService,
    private userState: UserState,
    public appState: AppState
  ) { }

  ngOnInit(): void {
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((response) => {
      this.userRole = response?.roles?.[0];
    });

    this.clientDashboardState.clientListUnderMarketing$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((investorList: any) => {
        this.selectedLeadStatus = this.filterVerificationStatusCtrl.value;
        if (this.filterVerificationStatusCtrl.value == 'engaged') {
          this.tableColumnList = [
            'clientName',
            'email',
            'totalActivityScore',
            'lastActivityDate',
            'leadType',
            'leadStatus',
            'emailVerificationDate',
            'createdDate',
          ];
        } else {
          this.tableColumnList = [
            'clientName',
            'email',
            'totalActivityScore',
            'lastActivityDate',
            'leadType',
            'leadStatus',
            'emailVerificationDate',
            'createdDate',
            'totalCount',
          ];
        }
        this.tableDataSource = new MatTableDataSource(investorList);
      });

    this.clientDashboardState.clientListUnderMarketingCount$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((count) => {
        this.investorUsersCount = count;
      });
    if (this.clientDashboardState.clickedThroughValue == null || this.clientDashboardState.clickedThroughValue == '') this.fetchUsersUnderMarketingEffectiveness();
  }

  ngAfterViewInit() {
    this.clientDashboardState.clickedThrough$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((response) => {
      if (response === 'click-through') {
        this.resetPaginatorAndFetchClients('click-through');
        // this.resetPaginatorAndFetchClients('click-through');
      } else if (response === 'engaged') {
        this.resetPaginatorAndFetchClients('engaged');
      }
    });
  }

  resetPaginatorAndFetchClients(recommendationType: string): void {
    this.clientFilterForm.reset();
    this.paginator.pageIndex = 0;
    this.fetchClientsParams = { orderBy: 'createdDate', orderType: 'desc', limit: 10, offset: 0 };
    this.clientFilterForm?.get('recommendationType').setValue(recommendationType);
    this.fetchUsersUnderMarketingEffectiveness();
  }

  ngOnChanges() {
    // if (this.filterForMarketingTab && this.filterForMarketingTab.length) {
    //   if (this.filterForMarketingTab == 'click-through') {
    //     this.clientFilterForm?.get('recommendationType').setValue('click-through');
    //     this.fetchUsersUnderMarketingEffectiveness();
    //   } else if (this.filterForMarketingTab == 'engaged') {
    //     this.clientFilterForm?.get('recommendationType').setValue('engaged');
    //     this.fetchUsersUnderMarketingEffectiveness();
    //   } else {
    //     this.resetFilter();
    //   }
    // }
  }

  fetchUsersUnderMarketingEffectiveness() {
    let requestData: any = {
      limit: this.fetchClientsParams.limit,
      offset: this.fetchClientsParams.offset,
      orderBy: this.fetchClientsParams.orderBy,
      orderType: this.fetchClientsParams.orderType,
      filter: {},
      searchClients: this.clientFilterForm.value.search,
    };

    if (this.filterVerificationStatusCtrl?.value == 'all' || this.filterVerificationStatusCtrl?.value == null) {
      delete requestData.filter.recommendationType;
    } else {
      requestData.filter.recommendationType = this.filterVerificationStatusCtrl.value;
    }
    if (!Object.keys(requestData.filter).length) {
      delete requestData.filter;
    }
    this.clientDashboardService.fetchInvestorsUnderMarketingEffectiveness(requestData).pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      this.isDataLoading = res.isLoading;
    });
  }

  sortTable(sortState: Sort) {
    this.paginator.pageIndex = 0;
    this.fetchClientsParams.limit;
    this.fetchClientsParams.offset = 0;
    this.fetchClientsParams.orderBy = sortState.active;
    this.fetchClientsParams.orderType = sortState.direction;
    this.fetchUsersUnderMarketingEffectiveness();
  }

  pageChange(event) {
    if (this.fetchClientsParams.offset != event.pageSize * event.pageIndex) {
      this.fetchClientsParams.limit = event.pageSize;
      this.fetchClientsParams.offset = event.pageSize * event.pageIndex;
    } else {
      this.fetchClientsParams.limit = event.pageSize;
      this.paginator.pageIndex = 0;
      this.fetchClientsParams.offset = 0;
    }

    this.fetchUsersUnderMarketingEffectiveness();
    this.clientListContainer.nativeElement.scrollTop = 0;
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
    this.clientDashboardState.openMarketingEffectivenessSheetValue = false;
  }

  resetFilter() {
    this.clearSearch = '';
    this.clientFilterForm?.get('recommendationType').setValue('all');
    this.clientFilterForm?.get('search').setValue('');
    this.fetchClientsParams.limit = 10;
    this.fetchClientsParams.offset = 0;
    this.paginator.pageSize = 10;
    this.paginator.pageIndex = 0;
    this.fetchUsersUnderMarketingEffectiveness();
    setTimeout(() => {
      this.clearSearch = 'hide';
    });
  }

  filterData() {
    if (this.paginator?.pageIndex) {
      this.paginator.pageIndex = 0;
      this.fetchClientsParams.limit = 10;
      this.fetchClientsParams.offset = 0;
    }
    this.fetchUsersUnderMarketingEffectiveness();
  }

  fetchClientMarketingDetails(clientDetails) {
    this.clientDashboardState.activeClientMarketingDetailsValue = clientDetails;
    this.clientDashboardState.openMarketingEffectivenessSheetValue = true;
  }

  public get filterVerificationStatusCtrl(): FormControl {
    return this.clientFilterForm.controls.recommendationType as FormControl;
  }
}
